"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _UITextInput = _interopRequireDefault(require("UIComponents/input/UITextInput"));

var FilterKeyValueInput =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(FilterKeyValueInput, _PureComponent);
  (0, _createClass2.default)(FilterKeyValueInput, null, [{
    key: "propTypes",
    get: function get() {
      return {
        labelConfig: _react.PropTypes.object,
        onBlur: _react.PropTypes.func.isRequired,
        onChange: _react.PropTypes.func.isRequired,
        value: _react.PropTypes.object
      };
    }
  }]);

  function FilterKeyValueInput(props) {
    var _this;

    (0, _classCallCheck2.default)(this, FilterKeyValueInput);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(FilterKeyValueInput).call(this, props));
    _this.validateInput = _this.validateInput.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2.default)(_this));
    _this.state = {
      isKeyValid: true,
      isValueValid: true
    };
    return _this;
  }

  (0, _createClass2.default)(FilterKeyValueInput, [{
    key: "validateInput",
    value: function validateInput(type, value) {
      var isInputValid = Boolean(value.length);
      var stateKey = type === 'key' ? 'isKeyValid' : 'isValueValid';
      this.setState((0, _defineProperty2.default)({}, stateKey, isInputValid));
    }
  }, {
    key: "getValueProp",
    value: function getValueProp() {
      var value = this.props.value;
      return value && value.get ? value.toJS() : value;
    }
  }, {
    key: "getKey",
    value: function getKey() {
      var value = this.getValueProp();
      return !value ? '' : value.name;
    }
  }, {
    key: "getValue",
    value: function getValue() {
      var value = this.getValueProp();
      return !value ? '' : value.value;
    }
  }, {
    key: "onKeyChange",
    value: function onKeyChange(key) {
      var onChange = this.props.onChange;
      var value = this.getValue();
      onChange({
        target: {
          value: {
            name: key.target.value,
            value: value
          }
        }
      });
    }
  }, {
    key: "onValueChange",
    value: function onValueChange(value) {
      var onChange = this.props.onChange;
      var name = this.getKey();
      onChange({
        target: {
          value: {
            name: name,
            value: value.target.value
          }
        }
      });
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(type) {
      var _this2 = this;

      return function (e) {
        _this2.validateInput(type, e.target.value);

        _this2.props.onBlur();
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var labelConfig = this.props.labelConfig;
      var configKey = labelConfig && labelConfig.queryParams && labelConfig.queryParams.key;
      var configValue = labelConfig && labelConfig.queryParams && labelConfig.queryParams.value;

      var keyPlaceholder = configKey || _I18n.default.text('AudienceTargeting.placeholders.queryParameter.key');

      var valuePlaceholder = configValue || _I18n.default.text('AudienceTargeting.placeholders.queryParameter.value');

      return _react.default.createElement("div", null, _react.default.createElement(_UITextInput.default, {
        error: !this.state.isKeyValid,
        className: "targeting-option__input short key",
        onBlur: this.handleBlur('key'),
        onChange: function onChange(input) {
          return _this3.onKeyChange(input);
        },
        placeholder: keyPlaceholder,
        value: this.getKey()
      }), _react.default.createElement("span", {
        className: "targeting-option__equal"
      }, '='), _react.default.createElement(_UITextInput.default, {
        error: !this.state.isValueValid,
        onBlur: this.handleBlur('value'),
        onChange: function onChange(input) {
          return _this3.onValueChange(input);
        },
        className: "targeting-option__input value",
        placeholder: valuePlaceholder,
        value: this.getValue()
      }));
    }
  }]);
  return FilterKeyValueInput;
}(_react.PureComponent);

exports.default = FilterKeyValueInput;
module.exports = exports.default;